import { PrimaryButtonMT, RoundButton, SecondaryButtonMT } from '@/components/buttons/Buttons';
import AddPeopleModal from '@/components/program/AddPeopleModal';
import { Table } from '@/components/table/Tables';
import { Column } from 'primereact/column';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import style from '../views/program.module.css';
import { useAuthenticationStore } from '@/store';
import { X4bUserRoleEnum } from '@/constants/roles';

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

type Props = {
	groups: Group[];
};

const People = (props: Props) => {
	const { groups } = props;
	const [showAddPeopleModal, setShowAddPeopleModal] = useState(false);
	const isManagerOrAdmin = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Admin, X4bUserRoleEnum.Manager]);

	const handleAddPeople = () => {
		setShowAddPeopleModal(true);
	};

	return (
		<>
			<div className="space-y-6">
				<div className="flex justify-between items-center">
					<h2 className="text-headline-medium text-neutral17">
						People
					</h2>
					{isManagerOrAdmin && (
						<SecondaryButtonMT
							id="add-people-program"
							label="Add People"
							onClick={handleAddPeople}

						/>)}
				</div>

				<Table
					value={groups}
					rowClassName={() => classNames(style.programGroupTableRow)}
					pt={{
						wrapper: {
							className: 'rounded-xl',
						},
					}}
				>
					<Column
						headerClassName={style.programGroupTableRow}
						field="name"
						header="Group Name"
						body={(rowData) => (
							<div>
								<p className="font-semibold">{rowData.name}</p>
								<p className="text-gray-500 text-xs">
									{rowData.description}
								</p>
							</div>
						)}
						sortable
					/>
					<Column
						headerClassName={style.programGroupTableRow}
						field="peopleCount"
						header="Number of People"
						sortable
					/>
				</Table>
			</div>
			<AddPeopleModal
				visible={showAddPeopleModal}
				setVisible={setShowAddPeopleModal}
				onHide={() => setShowAddPeopleModal(false)}
			/>
		</>
	);
};

export default People;
